import { getAntdTheme as getGeneratedAntdTheme } from '@env0/ui-theme/antd';
import type { ThemeConfig } from 'antd';
import { showHiddenFeatures } from 'constants/config';
import type { Env0Theme } from './themes.constants';
import { getLegacyAntdTheme } from './antd.constants.legacy';

export const selectAntdTheme = (theme: Env0Theme, useGeneratedTokens: boolean): ThemeConfig =>
  useGeneratedTokens ? getGeneratedAntdTheme(theme.mode) : getLegacyAntdTheme(theme);

export const getAntdTheme = (theme: Env0Theme): ThemeConfig => selectAntdTheme(theme, showHiddenFeatures());
